import { render, staticRenderFns } from "./RuleTest.vue?vue&type=template&id=548027f3&"
import script from "./RuleTest.vue?vue&type=script&lang=js&"
export * from "./RuleTest.vue?vue&type=script&lang=js&"
import style0 from "./RuleTest.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports